import React from 'react';
import './wrapper.scss';

export const View = ({ children, className }) => <div className={className}>{children}</div>;
